export default "__VITE_ASSET__DqRsyDdv__"